module.exports = __webpack_public_path__ + "static/header-b605046cb690da6d2744cf7b27e90574.png";